import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';

import { api_host, api_auth } from '../../../../../common/globals/constants';

import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
import { useTranslation, withTranslation } from 'react-i18next';
import compose from 'recompose/compose';
moment.locale('es')

class AvailabilityLine extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase(),
            chartOptions: this._chartOptionsBase(),
            isRefresh: this.props.params.isRefresh,
            date:this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
        }
    }
    _chartOptionsBase = () => {
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        return {
        chart: {
            type: 'areaspline'
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        title: {
            text: "",
        },
        xAxis: {
            gridLineWidth: 0,
            type: 'datetime',
            title: {
                text: null,
            },
            labels: {
                enabled: false
            },
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: "<br/><b>%e/%b</b>",
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            }
        },
        yAxis: {
            gridLineWidth: 0,
            title: {
                text: null,
            },
            labels: {
                enabled: false
            }
        },
        series: [],
        tooltip: {
            enabled: false,
            pointFormat: `${this.props.t('availability-line.graph.tooltip.point-format')}: <b>{point.y:.2f} (%)</b>`
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true
                }
            }
        },
        navigator: {
            enabled: null
        },
        lang: {
            loading: 'Cargando...',
            months: t('months', { returnObjects: true }),
            weekdays: t('weekDays', { returnObjects: true }),
            shortMonths: t('shortMonths', { returnObjects: true }),
            exportButtonTitle: t('availability-line.graph.lang.export"'),
            printButtonTitle: t('availability-line.graph.lang.import"'),
            rangeSelectorFrom: t('availability-line.graph.lang.from"'),
            rangeSelectorTo: t('availability-line.graph.lang.to"'),
            rangeSelectorZoom: t('availability-line.graph.lang.period"'),
            thousandsSep: ",",
            decimalPoint: '.'
        }
    }
    }

    setHoverData = (e) => {
        const { x, y, series } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        }else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod } = this.props.params
        const { history } = this.props;
        // puede necesitar agregar el schedule, guiarse por AvailabilityConsolidated
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/AvailabilityHourCustom/?user=${user}&objetiveId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            var newPeriod=period
            if(period==='3h'){
                newPeriod='h'
            }
            fetch(api_host+`/reporte/online/indicadores/AvailabilityHour/?user=${user}&objetiveId=${objetivo_id}&t=${newPeriod}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {

        let lastEventDict = []
        let chartDataUptime = []
        let ValueNavigator = false
        if (period === 'w' || fecha_inicio !== null) {
            ValueNavigator = true
        }
        let uptimeLast = ''
        let arrayChartDataMarked=[]
        let rowLen = externalData.data_pasos[0].data.length;
        const t = this.props.t
        externalData.data_pasos[0].data.forEach((dataDate, forEachKey) => {
            let dateJson = (new Date(dataDate.desde))
            let year = dateJson.getFullYear()
            let month = dateJson.getMonth()
            let day = dateJson.getDate()
            let hours = dateJson.getHours()
            let minutes = dateJson.getMinutes()
            let seconds = dateJson.getSeconds()
            var uptime = dataDate.data[0].uptime+dataDate.data[0].parcial+dataDate.data[0].no_monitoreo
            if(dataDate.data[0].mantenimiento){
                uptime+=dataDate.data[0].mantenimiento
                
            }
            
            
            
            if(dataDate.data[0].mantenimiento>0){
                //console.log(dataDate.desde,dataDate.data[0])
                let chartDataSeries = {}
                let dateStart = new Date(dataDate.desde)
                let dateEnd = new Date(dataDate.hasta)
                //console.log(moment(dateStart).unix(), dateEnd)
                chartDataSeries['from'] = moment(dateStart).unix()*1000
                chartDataSeries['to'] = moment(dateEnd).unix()*1000
                chartDataSeries['color'] = '#1976d2'
                chartDataSeries['zIndex'] = 1
                arrayChartDataMarked.push(chartDataSeries)
            }
            
            //console.log(forEachKey,rowLen-1)
            chartDataUptime.push([Date.UTC(year, (month), day, hours, minutes, seconds), parseFloat(uptime)])
            if (forEachKey == (rowLen - 1) /*&& key == 0*/) {
                lastEventDict['x'] = Date.UTC(year, (month), day, hours, minutes, seconds)
                lastEventDict['y'] = parseFloat(uptime)
                lastEventDict['name'] = 'uptime';
                if (period === 'h') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-4-hours')}`
                } else if (period === 'd') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
                } else if (period === 'w') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
                } else if (period === 'c') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${fecha_inicio} ${t('text.to2')} ${fecha_termino}`
                }
            }
        })
        //console.log(chartDataUptime)
        //console.log(arrayChartDataMarked)
        this.setState({
            chartOptions: {
                plotOptions: {
                    series: {
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        }
                    }
                },
                xAxis: {
                    plotBands: arrayChartDataMarked
                },
                navigator: {
                    enabled: ValueNavigator
                },
                series: [
                    {
                        data: chartDataUptime
                    }
                ]
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period
        });

    }
    render() {
        const { dataError, chartOptions, isLoading,chartOptionsBase } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (!dataError) {
            sessionStorage.setItem("chartAvailabilityLine",JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} />)
        }
        else if (dataError) {
            return (<p>{t('text.no-data')}</p>)
        }
        else return (<p>{t('availability-line.error')}</p>)

    }
}

function FormattedChart(props) {
    const { t } = useTranslation()
    return (
        <div >
            <div style={props.styleHidden}>
            <PortletContent>
                <PerfectScrollbar>

                    <Typography
                      variant="h5"
                    >
                     <CircularProgress
                      variant="indeterminate"

                      size={24}
                      thickness={4}
                      
                    />
                    <br/>
                     {t('text.loading')}
                   </Typography>
                  </PerfectScrollbar>
            </PortletContent>
            </div>
            <div style={props.style}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}


export default compose(withRouter, withTranslation())(AvailabilityLine);